import { compact, map } from 'lodash';
import React from 'react';
import { View } from 'react-native';
import AntDesign from 'react-native-vector-icons/AntDesign';
import Entypo from 'react-native-vector-icons/Entypo';
import EvilIcons from 'react-native-vector-icons/EvilIcons';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5Pro';
import Foundation from 'react-native-vector-icons/Foundation';
import Fontisto from 'react-native-vector-icons/Fontisto';
import Ionicons from 'react-native-vector-icons/Ionicons';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Zocial from 'react-native-vector-icons/Zocial';

const icons = [
  AntDesign,
  Ionicons,
  MaterialIcons,
  Entypo,
  EvilIcons,
  Feather,
  FontAwesome5,
  Fontisto,
  Foundation,
  MaterialCommunityIcons,
  Zocial,
];

type Props = {
  name: string;
  color?: string;
  size?: number;
  style?: any;
};

const Icon = ({ name, size = 25, color = 'black', style }: Props) => {
  const Icon = compact(
    map(icons, (Icon) => {
      if (Icon.hasIcon(name)) {
        return <Icon name={name} size={size} color={color} style={style} />;
      }
      return null;
    })
  );

  return <View>{Icon[0]}</View>;
};

export default Icon;
